import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { marketing } from '../services/api';
import { Bell, Loader2, Ticket, Tag, Award, Gavel, Building2, ExternalLink } from 'lucide-react';

const ICONS = {
  listing:  Building2,
  coupon:   Tag,
  loyalty:  Award,
  auction:  Gavel,
  event:    Ticket,
};
const LABELS = {
  listing: 'Listing', coupon: 'Coupon', loyalty: 'Loyalty program',
  auction: 'Auction item', event: 'Event',
};

// Business Owner Dashboard widget — shows the most recent updates the
// system auto-collected from the owner's active sections. Everything a
// subscribed contact will see referenced in tomorrow's digest email.
export default function UpdatesBucket({ businessId = null, limit = 20 }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    marketing.ownerUpdates(businessId, limit).then(setRows).catch(() => setRows([]));
  }, [businessId, limit]);

  return (
    <section className="pbb-card p-5" data-testid="updates-bucket">
      <div className="flex items-center gap-2 mb-3">
        <Bell size={18} className="text-yellow-400"/>
        <h3 className="text-white font-semibold">Updates Bucket</h3>
        <div className="ml-auto text-[11px] text-gray-500">Feeds tomorrow's digest to your subscribers.</div>
      </div>
      {rows === null ? (
        <div className="text-gray-400 text-sm inline-flex items-center gap-2"><Loader2 size={13} className="animate-spin"/> Loading…</div>
      ) : rows.length === 0 ? (
        <div className="text-center py-6" data-testid="updates-bucket-empty">
          <div className="text-sm text-gray-300">No updates yet</div>
          <p className="text-xs text-gray-500 mt-1">When you add or edit a listing, coupon, loyalty program, auction item, or event, it shows up here automatically.</p>
        </div>
      ) : (
        <ul className="space-y-2" data-testid="updates-bucket-list">
          {rows.map(r => {
            const Icon = ICONS[r.entityType] || Bell;
            return (
              <li key={r.id} className="flex items-start gap-3 p-2 rounded-lg hover:bg-white/5" data-testid={`update-row-${r.id}`}>
                <div className="mt-0.5 text-gray-400"><Icon size={14}/></div>
                <div className="flex-1 min-w-0">
                  <div className="text-white text-sm truncate">{r.title}</div>
                  <div className="text-[11px] text-gray-500">
                    {LABELS[r.entityType] || r.entityType} · {r.action} · {new Date(r.createdAt).toLocaleString(undefined, {month:'short', day:'numeric', hour:'numeric', minute:'2-digit'})}
                  </div>
                </div>
                {r.link && (
                  <Link to={r.link} data-testid={`update-link-${r.id}`}
                    className="text-[11px] text-green-400 hover:text-green-300 inline-flex items-center gap-1 shrink-0">
                    Open <ExternalLink size={10}/>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
